import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'UserLogin',
    component: () => import('@/views/UserLogin.vue')
  },
  {
    path: '/summary',
    name: 'AchievementSummary',
    component: () => import('@/views/AchievementSummary.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/map',
    name: 'PeakMap',
    component: () => import('@/views/MapView.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/challenges',
    name: 'UserChallenges',
    component: () => import('@/views/ChallengesView.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/peaks',
    name: 'MyPeaks',
    component: () => import('@/views/PeaksView.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/activities',
    name: 'Activities',
    component: () => import('@/views/ActivitiesView.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/rankings',
    name: 'Rankings',
    component: () => import('@/views/RankingsView.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/ErrorView.vue')
  },
  {
    path: '/admin/challenges',
    name: 'AdminChallenges',
    component: () => import('@/views/AdminChallengesView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/connect-strava',
    name: 'StravaConnect',
    component: () => import('@/views/StravaConnectView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    redirect: '/summary'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  console.log('Router guard:', {
    path: to.path,
    requiresAuth: to.meta.requiresAuth,
    requiresStrava: to.meta.requiresStrava,
    requiresAdmin: to.meta.requiresAdmin,
    isAuthenticated: authStore.isAuthenticated,
    isStravaConnected: authStore.isStravaConnected,
    isAdmin: authStore.isAdmin,
    user: authStore.user
  })
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresStrava && authStore.isAuthenticated && !authStore.isStravaConnected) {
    console.log('Redirecting to /connect-strava because requiresStrava and not connected')
    next('/connect-strava')
  } else if (to.meta.requiresAdmin && authStore.isAuthenticated && !authStore.isAdmin) {
    console.log('Redirecting to /summary because requiresAdmin and not admin')
    next('/summary')
  } else {
    next()
  }
})

export default router